/**
 * Login page brand theme selector & brand configuration.
 *
 * Reads `VITE_LOGIN_THEME` at build time to determine which company's
 * visual design and contact information to render on the login page:
 *
 *   VITE_LOGIN_THEME=primrose  ->  Primrose Health (teal brand)
 *   VITE_LOGIN_THEME=iris      ->  Iris Health (blue brand)
 *
 * Defaults to 'primrose' when unset or unrecognised.
 */

export type LoginTheme = 'primrose' | 'iris';

export interface BrandConfig {
  name: string;
  billingPhoneDisplay: string;
  billingPhoneTel: string;
}

function readTheme(): LoginTheme {
  const env = (import.meta as ImportMeta).env;
  const raw = (env as Record<string, string | undefined>)['VITE_LOGIN_THEME'];
  if (raw === 'iris') return 'iris';
  return 'primrose';
}

export const LOGIN_THEME: LoginTheme = readTheme();

export const BRAND_CONFIGS: Record<LoginTheme, BrandConfig> = {
  primrose: {
    name: 'Primrose Health',
    billingPhoneDisplay:
      (import.meta as ImportMeta).env.VITE_BILLING_PHONE ??
      (import.meta as ImportMeta).env.VITE_PRIMROSE_BILLING_PHONE ??
      '(800) 555-1212',
    billingPhoneTel:
      (import.meta as ImportMeta).env.VITE_BILLING_PHONE_TEL ??
      (import.meta as ImportMeta).env.VITE_PRIMROSE_BILLING_PHONE_TEL ??
      '+18005551212',
  },
  iris: {
    name: 'Iris Health',
    billingPhoneDisplay:
      (import.meta as ImportMeta).env.VITE_BILLING_PHONE ??
      (import.meta as ImportMeta).env.VITE_IRIS_BILLING_PHONE ??
      '(888) 777-9900',
    billingPhoneTel:
      (import.meta as ImportMeta).env.VITE_BILLING_PHONE_TEL ??
      (import.meta as ImportMeta).env.VITE_IRIS_BILLING_PHONE_TEL ??
      '+18887779900',
  },
};

export const CURRENT_BRAND: BrandConfig = BRAND_CONFIGS[LOGIN_THEME];
